import { ContactInfoItem, OpeningHourItem, StoreApiData, TimeRangeItem, TransformedStoreItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo/type";

export const mapDayToVietnamese = (day: string): string => {
    const dayMap: Record<string, string> = {
        monday: "THỨ 2",
        tuesday: "THỨ 3",
        wednesday: "THỨ 4",
        thursday: "THỨ 5",
        friday: "THỨ 6",
        saturday: "THỨ 7",
        sunday: "CHỦ NHẬT",
    }
    return dayMap[day.toLowerCase()] || day.toUpperCase()
}

export const formatTime = (time: string): string => {
    if (!time) return ""
    const timeWithoutSeconds = time.split(".")[0]
    if (timeWithoutSeconds.split(":").length === 3) {
        return timeWithoutSeconds.substring(0, 5)
    }
    return timeWithoutSeconds
}

export const transformTimeRange = (timeRange: TimeRangeItem[]): OpeningHourItem[] => {
    if (!timeRange || timeRange.length === 0) return []

    return timeRange.map((item) => ({
        day: mapDayToVietnamese(item.day),
        hours: `${formatTime(item.from)} - ${formatTime(item.to)}`,
    }))
}

export const transformStoreData = (apiData: StoreApiData[]): TransformedStoreItem[] => {
    return apiData.map((item) => {
        const { attributes } = item

        const contactInfo: ContactInfoItem[] = []

        if (attributes.address) {
            contactInfo.push({
                value: attributes.address,
                link: "",
            })
        }

        if (attributes.email) {
            contactInfo.push({
                value: attributes.email,
                link: `mailto:${attributes.email}`,
            })
        }

        if (attributes.phone) {
            const phoneNumber = attributes.phone.replace(/\s+/g, "").replace(/[^\d+]/g, "")
            contactInfo.push({
                value: attributes.phone,
                link: `tel:${phoneNumber}`,
            })
        }

        if (attributes.latitude && attributes.longitude && (attributes.latitude !== 0 || attributes.longitude !== 0)) {
            const gpsUrl = `https://www.google.com/maps?q=${attributes.latitude},${attributes.longitude}`
            contactInfo.push({
                value: `GPS: ${attributes.latitude}, ${attributes.longitude}`,
                link: gpsUrl,
            })
        }

        if (attributes.googleMapCode && attributes.googleMapCode !== "string") {
            let googleMapsUrl = attributes.googleMapCode
            if (!googleMapsUrl.startsWith("http://") && !googleMapsUrl.startsWith("https://")) {
                googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(attributes.googleMapCode)}`
            }
            contactInfo.push({
                value: `Google Maps: ${attributes.googleMapCode}`,
                link: googleMapsUrl,
            })
        }

        const openingHours = transformTimeRange(attributes.timeRange || [])

        return {
            id: item.id,
            title: attributes.name,
            image: attributes.image,
            contactInfo,
            openingHours: openingHours.length > 0 ? openingHours : undefined,
            // Guidance đã được soạn sẵn (có cấu trúc/style) trong editor → giữ nguyên
            // HTML, render thẳng ở RightSidebar thay vì bóc tách rồi dựng lại. Tránh
            // lỗi mất "chỉ đường" khi editor xuất HTML khác cấu trúc parser giả định.
            guidance: attributes.guidance || undefined,
        }
    })
}
